import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './TelegramButton.css';

const TelegramButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Your Telegram group/channel link
  const TELEGRAM_LINK = 'https://t.me/adhvaacademy';

  useEffect(() => {
    // Show button after a short delay when page loads
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleTelegramClick = () => {
    window.open(TELEGRAM_LINK, '_blank', 'noopener,noreferrer');
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);
    // Save to localStorage so it doesn't show again in this session
    localStorage.setItem('telegram_button_closed', 'true');
  };

  const handleMouseEnter = () => {
    setIsExpanded(true);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
    setShowTooltip(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`telegram-button-container ${isExpanded ? 'expanded' : ''}`}>
      <button
        className="telegram-button"
        onClick={handleTelegramClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        aria-label="Join our Telegram community"
      >
        <span className="telegram-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.22 15.51 15.99C15.37 16.74 15.09 16.99 14.83 17.01C14.25 17.07 13.81 16.64 13.25 16.27C12.37 15.69 11.87 15.33 11.02 14.77C10.03 14.12 10.67 13.76 11.24 13.18C11.39 13.03 13.95 10.7 14 10.49C14.0069 10.4582 14.006 10.4252 13.9973 10.3938C13.9886 10.3624 13.9724 10.3337 13.95 10.31C13.89 10.26 13.81 10.28 13.74 10.29C13.65 10.31 12.25 11.24 9.52 13.08C9.12 13.35 8.76 13.49 8.44 13.48C8.08 13.47 7.4 13.28 6.89 13.11C6.26 12.91 5.77 12.8 5.81 12.45C5.83 12.27 6.08 12.09 6.55 11.9C9.47 10.63 11.41 9.79 12.38 9.39C15.16 8.23 15.73 8.03 16.11 8.03C16.19 8.03 16.38 8.05 16.5 8.15C16.6 8.23 16.63 8.34 16.64 8.42C16.63 8.48 16.65 8.66 16.64 8.8Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className={`telegram-text ${isExpanded ? 'show' : ''}`}>
          Join our Telegram
        </span>
        <button
          className="telegram-close"
          onClick={handleClose}
          aria-label="Close Telegram button"
        >
          <X size={16} />
        </button>
      </button>

      {showTooltip && (
        <div className="telegram-tooltip">
          <div className="telegram-tooltip-title">Join Our Community! 🚀</div>
          <div className="telegram-tooltip-text">
            Get daily updates, study materials, and connect with fellow aspirants
          </div>
        </div>
      )}
    </div>
  );
};

export default TelegramButton;
